import { declineTypes } from "./arpsUtils";

export function getDeclineTitleWithType(title, declineType) {
  return `${title} (${declineTypes[declineType]})`;
}
